<template>
    <div style="position: relative;" @touchstart.stop="touchStart($event)" @touchmove.stop.prevent="touchMove($event)" @touchend.stop="touchEnd($event)" ref="container">
        <div style=" transform:translateY(0px); margin-top: -34px;" :style="{ transform: 'translateY(' + transformY + 'px) translateX(' + transformX + 'px)', transition: isAnimating ? 'transform 0.2s linear' : '' }">
            <div class="each_row" v-for="each, i in list" :key="i" :class="[curIndex === i ? 'active' : '', curIndex + 1 === i ? 'upAndDown' : '', curIndex - 1 === i ? 'upAndDown' : '']" style="line-height:30px;" :style="{ height: height + 'px', textAlign: textAlign }" @click="touchLabel(i)">{{ each.label }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CommonScrollSelector",
    props: {
        list: {
            type: Array,
            default: () => { }
        },
        initValue: {
            type: String,
            default: '',
        },
        detectValueChange: {
            type: Function,
            default: () => { }
        },
        textAlign: {
            type: String,
            default: 'center'
        },
        test: {
            type: String,
            default: ""
        },
        transformX: {
            type: Number,
            default: 0
        },
        textLeft: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            curIndex: -1,
            startY: 0,
            transformY: 0,
            lastTransformY: 0,
            yMoves: [],
            height: 30,
            containerHeight: 0,
            halfContainerHeight: 0,
            isAnimating: false,
            diff_y: 0,
        }
    },
    watch: {
        initValue() {
            console.log('initValue changed');
            this.refreshCenter();
        }
    },
    methods: {
        test2(){
            console.log('test2')
        },
        touchStart(e) {
            console.log('touchstart');
            this.startY = e.touches[0].pageY;
        },
        touchMove(e) {
            const curY = e.touches[0].pageY;
            const diffY = (curY - this.startY);
            this.diff_y = diffY;
            this.transformY = this.lastTransformY + parseInt(diffY);
            this.yMoves.push(curY);
        },
        touchEnd() {
            if (this.transformY > this.halfContainerHeight) {
                this.yMoves = [];
                this.setCenterAnimated(0);
                return;
            }

            // console.log(this.transformY, this.list.length * this.height - this.halfContainerHeight);
            // 30분단위 scroll 리셋
            if (this.transformY < 56 && this.list.length === 2) {
                this.yMoves = [];
                this.setCenterAnimated(this.list.length - 1);
                return
            }

            if ((this.transformY < 0 && Math.abs(this.transformY) > Math.abs(this.list.length * this.height - this.halfContainerHeight))) {
                this.yMoves = [];
                this.setCenterAnimated(this.list.length - 1);
                return;
            }

            this.lastTransformY = parseInt(this.transformY);
            const totalMovesCnt = this.yMoves.length;
            if (totalMovesCnt > 7) {
                const accelerationFactor = this.yMoves[totalMovesCnt - 1] - this.yMoves[totalMovesCnt - 6];
                if (Math.abs(accelerationFactor) > 24) {
                    if (accelerationFactor > 0) {
                        this.setCenterAnimated(0);
                    } else {
                        this.setCenterAnimated(this.list.length - 1);
                    }
                } else {
                    this.fitLocation();
                }
            } else {
                this.fitLocation();
            }

            this.yMoves = [];
        },
        fitLocation() {
            this.setCenterAnimated(parseInt((this.halfContainerHeight - this.transformY) / this.height));
        },
        setCenterAnimated(index) {
            this.isAnimating = true;
            this.$nextTick(() => {
                this.setCenter(index);
                setTimeout(() => {
                    this.isAnimating = false;
                }, 200)
            });
        },
        setCenter(index) {
            const transformY = this.containerHeight * 0.5 - index * this.height - this.height * 0.5;
            this.curIndex = index;
            this.transformY = transformY;
            this.lastTransformY = transformY;
            this.detectValueChange(this.list[index]);
        },
        touchLabel(index) {
            this.setCenterAnimated(index);
        },
        refreshCenter() {
            this.containerHeight = this.$refs.container.offsetHeight;
            this.halfContainerHeight = this.$refs.container.offsetHeight * 0.5;

            let index = 0;
            const findindex = this.list.findIndex((each) => each.value === this.initValue);
            if (findindex > -1)
                index = findindex;

            this.setCenter(index);
        }
    },
    mounted() {
        this.refreshCenter();
    },
    created() {

    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

.each_row {
    font-size: 20px;
    color: #cccccc;
}

.each_row.active {
    font-weight: 500;
    color: #606060;
}

.each_row.upAndDown {
    color: #aaaaaa
}
</style>